import { Subject } from 'rxjs';

const isFunction = (fn) => typeof fn === 'function';

const doUnsubscribe = (subscription) => {
  if (subscription && isFunction(subscription.unsubscribe)) {
    try {
      subscription.unsubscribe();
    } catch (e) {
      console.log(`Error during unsubscribe:`, e);
    }
  }
};

const findAndDoUnsubscribes = (properties: string[], component: any): void => {
  properties.forEach((p) => {
    const property = component[p];
    doUnsubscribe(property);
  });
};

const getUnsubProperties = (blackList: string[], component: any): string[] => {
  const componentProperties = Object.getOwnPropertyNames(component);
  return componentProperties.reduce((props, p) => {
    if (!blackList.includes(p) && Object.prototype.hasOwnProperty.call(component, p)) {
      const property = component[p];
      if (!(property instanceof Subject) && isFunction(property?.unsubscribe)) {
        props.push(p);
      }
    }
    return props;
  }, []);
};

export function AutoUnsubscribe({ blackList = ['eventEmitter'] } = {}) {
  return function (constructor: Function) {
    const originalOnDestroy = constructor.prototype.ngOnDestroy;
    constructor.prototype.ngOnDestroy = function () {
      originalOnDestroy?.apply(this, arguments);
      const toUnsubProperties = getUnsubProperties(blackList, this);

      if (toUnsubProperties.length) {
        findAndDoUnsubscribes(toUnsubProperties, this);
      }
    };
  };
}
